import { css, createGlobalStyle } from 'styled-components';
import Fonts from './Fonts';
import { Media } from 'assets/Mixins.style';
export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    height: 100%;
    font-family: ${props => props.theme.fontFamily};
    font-size: ${props => (props.scale ? `${62.5 * props.scale}%` : '62.5%')};
    line-height: 1.15;
  }

  body {
    height: 100%;
    font-size: 1.6rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.665;
    overflow: auto;
  }

  strong {
    font-weight: 700;
  }

  a {
    text-decoration: none;
  }

  #root {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    background: ${props => props.theme.background};
    background-size: auto, 100% auto;

    ${Media.lg`
      background: ${props =>
        props.theme.backgroundOnMobile || props.theme.background};
    `}

    ${props =>
      props.fullmode &&
      css`
        height: 100%;
      `}

    ${props =>
      props.highContrast &&
      !props.mourning &&
      css`
        filter: invert(1);
      `}

  ${props =>
    !props.highContrast &&
    props.mourning &&
    css`
      filter: grayscale(1);
    `}

  ${props =>
    props.highContrast &&
    props.mourning &&
    css`
      filter: invert(1) grayscale(1);
    `}
  }
`;
console.log('hello world', Fonts['Lato'], Fonts['Lato'][300]);
export const GlobalFontsStyles = createGlobalStyle`
 @font-face {

   ${props =>
     props.theme.primaryFontName &&
     props.theme.primaryFont &&
     Fonts[props.theme.primaryFont] &&
     css`
       font-family: ${props => props.theme.primaryFontName};
       src: url(${props => `${Fonts[props.theme.primaryFont].eot}`});
       src: url(${props => `${Fonts[props.theme.primaryFont].eot}?#iefix`})
           format('embedded-opentype'),
         url(${props => `${Fonts[props.theme.primaryFont].woff2}`})
           format('woff2'),
         url(${props => `${Fonts[props.theme.primaryFont].woff}`})
           format('woff'),
         url(${props => `${Fonts[props.theme.primaryFont].ttf}`})
           format('truetype'),
         url(${props =>
             `${Fonts[props.theme.primaryFont].svg}#${
               props.theme.primaryFont
             }`})
           format('svg');
       font-weight: 400;
       font-style: normal;
     `}
  }

 @font-face {
  ${props =>
    props.theme.secondaryFontName &&
    props.theme.secondaryFont &&
    Fonts[props.theme.secondaryFont] &&
    css`
      font-family: ${props => props.theme.secondaryFontName};
      src: url(${props => `${Fonts[props.theme.secondaryFont].eot}`});
      src: url(${props => `${Fonts[props.theme.secondaryFont].eot}?#iefix`})
          format('embedded-opentype'),
        url(${props => `${Fonts[props.theme.secondaryFont].woff2}`})
          format('woff2'),
        url(${props => `${Fonts[props.theme.secondaryFont].woff}`})
          format('woff'),
        url(${props => `${Fonts[props.theme.secondaryFont].ttf}`})
          format('truetype'),
        url(${props =>
            `${Fonts[props.theme.secondaryFont].svg}#${
              props.theme.secondaryFont
            }`})
          format('svg');
      font-weight: 400;
      font-style: normal;
    `}
  }


  ${props =>
    props.theme.primaryFontName &&
    props.theme.primaryFont &&
    Fonts[props.theme.primaryFont] &&
    Fonts[props.theme.primaryFont][300] &&
    css`
      @font-face {
        font-family: ${props => props.theme.primaryFontName};
        font-weight: 300;
        font-style: normal;
        font-display: swap;

        src: url(${props => `${Fonts[props.theme.primaryFont][300].woff2}`})
            format('woff2'),
          url(${props => `${Fonts[props.theme.primaryFont][300].woff}`})
            format('woff');
        font-weight: 300;
        font-style: normal;
        unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6,
          U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122,
          U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
      }

      @font-face {
        font-family: ${props => props.theme.primaryFontName};
        font-weight: 300;
        font-style: normal;
        font-display: swap;

        src: url(${props => `${Fonts[props.theme.primaryFont][300].woff2Ext}`})
            format('woff2'),
          url(${props => `${Fonts[props.theme.primaryFont][300].woffExt}`})
            format('woff');
        font-weight: 300;
        font-style: normal;
        unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7,
          U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F,
          U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F,
          U+A720-A7FF;
      }
    `}
`;
